import React from 'react';
import { CheckCircle } from '@phosphor-icons/react';

/**
 * Sprint C — QuietWinsCard
 * Positive reinforcement. Composes from /home/briefing.wins (existing array)
 * and silently auto-hides if there's nothing genuine to celebrate.
 */
export const QuietWinsCard = ({ wins }) => {
  if (!wins || wins.length === 0) return null;

  return (
    <section data-testid="quiet-wins" aria-labelledby="quiet-wins-heading">
      <h3
        id="quiet-wins-heading"
        className="text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-500 mb-3 px-1"
      >
        Quiet wins
      </h3>
      <ul className="space-y-2">
        {wins.slice(0, 3).map((w, i) => {
          const text = typeof w === 'string' ? w : (w.text || w.label || w.title || '');
          if (!text) return null;
          return (
            <li
              key={i}
              data-testid={`quiet-win-${i}`}
              className="flex items-start gap-3 bg-emerald-50/60 border border-emerald-100 rounded-xl px-4 py-3"
            >
              <CheckCircle
                size={16}
                weight="duotone"
                className="text-emerald-500 flex-shrink-0 mt-0.5"
                aria-hidden
              />
              <span className="text-[13.5px] text-[#1F3A2E] leading-relaxed">{text}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default QuietWinsCard;
